import { render } from "./MessengerBotPropsCmp.vue?vue&type=template&id=349221c2"
import script from "./MessengerBotPropsCmp.vue?vue&type=script&lang=js"
export * from "./MessengerBotPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__